import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './base';

export const baseApi = createApi({
	reducerPath: 'baseApi',
	tagTypes: [
		'Auth',
		'User',

		'Employees',
		'Employee',

		'DebitCards',

		'CompanyProfile',
		'CompanyAdmins',
		'CompanyDirectDebit',
		'EmployeesTaxreliefs',
		'BenefitConfigs',
		'TaxReliefEmployees',

		'TopUpOrders',

		'UserBenefits',
	],
	baseQuery: baseQueryWithReauth,
	// setupListeners(store.dispatch) is already called in src/app/store/store.js, which is the
	// prerequisite for this flag — it makes every active query subscription across the app
	// automatically refetch when the browser regains connectivity, instead of staying stuck on
	// whatever error/stale state it was in when the connection dropped mid-request.
	refetchOnReconnect: true,
	endpoints: () => ({}),
});
